var map = {
	"./american_express.png": "d4c9",
	"./american_express@2x.png": "cb34",
	"./amex.png": "7543",
	"./amex@2x.png": "f116",
	"./credit.png": "7e01",
	"./dankort.png": "c5b7",
	"./diners.png": "22b2",
	"./discover.png": "3f91",
	"./forbru.png": "775c",
	"./google.png": "4655",
	"./jcb.png": "00d2",
	"./laser.png": "e6f0",
	"./maestro.png": "1e86",
	"./mastercard.png": "aea1",
	"./money.png": "a03d",
	"./paypal.png": "ca9b",
	"./shopify.png": "b5cf",
	"./solo.png": "a77e",
	"./visa.png": "bce3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6501";